/**
 * Incoming message for the logged-in operator (device/user sent toward the web client).
 * @param {object} message
 * @param {string|undefined} operatorUserId
 */
export function isIncomingOperatorMessage (message, operatorUserId) {
  if (!message || !operatorUserId) return false
  if (message.senderUserId === operatorUserId && !message.senderDeviceId) return false
  if (message.senderDeviceId) return true
  if (message.senderUserId && message.senderUserId !== operatorUserId) return true
  return false
}
